import { Button } from 'components/buttons'
import { getInitialStateSubMenu } from 'components/dynamicTab'
import { Icons } from 'interfaces'
import React, { FC } from 'react'
import { useFieldArray } from 'react-hook-form'
import { ElementItemSubMenu } from './ElementItemSubMenu'
import { SubMenuTabItemProps } from './SubMenuTabItem.type'

export const SubMenuTabItem: FC<SubMenuTabItemProps> = (props): JSX.Element => {
	const {
		errors,
		control,
		fieldError,
		isValid,
		name,
		setValue,
		register,
		watch,
		setErrorForm,
		setFieldError,
		saveData
	} = props

	const { fields, append, remove } = useFieldArray({
		control,
		name: `${name}.sub_menus` as `tabs.${number}.setup_menu`
	})

	return (
		<div>
			{fields.map((_component, index) => (
				<div key={`sub-menu-${index}`}>
					<ElementItemSubMenu
						menuIndex={index}
						name={name}
						errors={errors}
						control={control}
						isValid={isValid}
						fieldError={fieldError}
						remove={remove}
						register={register}
						setValue={setValue}
						watch={watch}
						saveData={saveData}
						setFieldError={setFieldError}
						setErrorForm={setErrorForm}
					/>
				</div>
			))}
			<div
				aria-hidden="true"
				className="flex  min-w-[100px] justify-center items-center"
			>
				<Button
					label="Add Sub Menu"
					className="w-full md:w-auto my-2"
					iconRight={Icons.plus}
					color="white"
					onClick={() => {
						const maxOrder = Math.max(
							...fields.map(c => c.section_order as number),
							0
						)
						append({ ...getInitialStateSubMenu, section_order: maxOrder + 1 })
					}}
				/>
			</div>
		</div>
	)
}
